import React from 'react';

const Loading = ({ customMessage }) => {
  // useEffect(() => {
  //   const contentArea = document.querySelector('#contentArea');
  //   const htmlTag = document.documentElement;
  //   if (!contentArea) {
  //     htmlTag.setAttribute('data-show', 'false');
  //   } else {
  //     contentArea.style = 'opacity:0';
  //   }
  //   document.body.classList.add('spinner');
  //   return () => {
  //     setTimeout(() => {
  //       if (!contentArea) {
  //         htmlTag.setAttribute('data-show', 'true');
  //       } else {
  //         contentArea.style = 'opacity:1';
  //       }
  //       document.body.classList.remove('spinner');
  //     }, 30);
  //   };
  // }, []);

  return (
    <>
      <div style={{ display: 'grid', placeItems: 'center', width: '100%', height: '100%' }}>
        <h4>{customMessage || 'LOADING...'}</h4>
      </div>
    </>
  );
};

export default Loading;
